<template>
  <div class="stepBox">
    <div class="step">
      <qiangzhi ref="qiangzhijieguoRef" />
      <qiangzhiForm />
    </div>
    <fengxian :type="2" />
    <fuwu :type="2" />
    <mElectronicFooter disabledNext />

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixins from "./mixins";
import qiangzhiForm from "@/views/ContractInsurance/qiangzhi.vue";

export default {
  mixins: [mixins],
  components: {
    qiangzhiForm,

  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
@use "~@/views/hetongqianshu/step/index.scss" as *;
</style>
